import React, { useState } from "react";
import { Box, Typography, Button, Divider, IconButton } from "@mui/material";
import { Add, Remove } from "@mui/icons-material";
import { useDispatch } from "react-redux";
import { setTabIndex } from "../../ReduxStore/UserSlice";
import { useNavigate } from "react-router-dom";

const faqs = [
  {
    question:
      "What is an MSME loan for a new business, and how can Dequitec help me get one?",
    answer:
      "Dequitec helps new businesses get MSME loans by connecting them with the right lenders and managing the end-to-end process. We make it simple with fast checks, expert assistance, and fast approvals - no hassle!",
  },
  {
    question:
      "How do I qualify for an unsecured business loan in Delhi with Dequitec’s assistance?",
    answer:
      "To get an unsecured business loan in Delhi with Dequitec, you just need a registered business, steady income, and basic documents. We make it simple by quickly checking your eligibility, matching you with the right lender, and guiding you through the approval process, no collateral needed.",
  },
  {
    question:
      "Why should I choose a business loan consultant instead of applying directly to banks?",
    answer:
      "A business loan consultant helps you find the best loan faster by connecting you with multiple lenders, improving your approval chances, and handling all the paperwork. It’s quicker, easier, and often gets you better terms than going directly to a bank.",
  },
  {
    question:
      "How can Dequitec’s loan eligibility checker help me find the right funding options?",
    answer:
      "Our loan eligibility checker quickly reviews your business profile and financial details to match you with the most suitable funding options from trusted lenders. It saves you time, eliminates guesswork, and helps you find the right loan faster.",
  },
  {
    question:
      "What are the benefits of taking a small business loan in Faridabad through Dequitec?",
    answer:
      "Small businesses in Faridabad get quick access to trusted lenders, competitive interest rates, and fast approvals. We have in-depth knowledge of the local market, which makes the loan process simple, including minimal paperwork and full support at every step.",
  },
  {
    question: "How does the business loan eligibility calculator on Dequitec work?",
    answer:
      "Just by entering a few simple details such as  Nature of Entity, Nature of Business, How old is the business, revenue, End use of funds, and Any history of EMI delay or Default. The calculator will instantly show how much loan you’re eligible for, making it easier to plan your next steps.",
  },
  {
    question: "Can I get a business loan without collateral for a startup or MSME?",
    answer:
      "Yes, we help startups and MSMEs get unsecured business loans based on their credit score and business potential. You don’t need to provide any collateral or assets as security.",
  },
  {
    question:
      "What documents are required for applying for a new business loan through Dequitec?",
    answer:
      "These are the documents you need:\n\nPAN card\n\nAadhaar card\n\nBusiness registration proof\n\nBank statements (last 6–12 months)\n\nITR or financial statements. Additional documents may vary depending on the lender.",
  },
  {
    question:
      "Does Dequitec assist with improving loan eligibility for small business owners?",
    answer:
      "Yes, we provide guidance on improving your credit score, organizing financials, and choosing the right loan product to boost your eligibility.",
  },
  {
    question:
      "In how many days can I get approval for a small business or MSME loan with Dequitec’s help?",
    answer:
      "Loan approval times with us depend on your business profile and how quickly you submit the required documents. Our expert support and streamlined process help move things along faster than traditional methods.",
  },
];

const QuestionAnswer = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [openIndex, setOpenIndex] = useState(null);
  const DISPLAYED_FAQ_COUNT = 4;

  const handleToggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  const visibleFaqs = faqs.slice(0, DISPLAYED_FAQ_COUNT);

  return (
    <Box sx={{ paddingX: { xs: 2, sm: 4, lg: 18 }, paddingY: 5 }}>
      {/* Centered Line & Title */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 2,
          marginBottom: 1,
        }}
      >
        <Box
          sx={{ width: "50px", height: "3px", backgroundColor: "#004AAD" }}
        />
        <Typography variant="h7" sx={{ fontWeight: "bold", color: "#004AAD" }}>
          Frequently Asked Questions (FAQs)
        </Typography>
      </Box>
      {/* Heading */}
      <Typography
        variant="h6"
        fontWeight="bold"
        textAlign="center"
        gutterBottom
        sx={{ fontSize: { xs: "1.2rem", sm: "1.4rem", md: "1.6rem" } }}
      >
        Everything You Need to Know
      </Typography>
      <Typography
        variant="subtitle2"
        fontStyle="italic"
        textAlign="center"
        sx={{
          margin: "0 auto",
          marginBottom: 4,
          color: "#333333",
          fontSize: { xs: "10px", sm: "12px", md: "14px" },
        }}
      >
        Have questions about business funding? Here are quick answers to help
        you understand how Dequitec works, choose the right loan, and get
        started easily!
      </Typography>

      {/* FAQs Section */}
      {visibleFaqs.map((faq, index) => (
        <Box
          key={index}
          sx={{
            marginBottom: 2,
            paddingX: { sm: 6, md: 8, lg: 1 },
            width: "100%",
          }}
        >
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            sx={{
              marginBottom: 0, // Removed margin for mobile to reduce space
              gap: 1, // Adjusted gap between question and icon
              cursor:"pointer"
            }}
            onClick={() => handleToggle(index)}
          >
            <Typography
              color="#004AAD"
              fontWeight="bold"
              sx={{
                cursor: "pointer",
                fontSize: { xs: "14px", sm: "18px" },
                fontWeight: 600,
                wordWrap: "break-word",
                maxWidth: "80%",
              }}
            >
              {faq.question}
            </Typography>
            <IconButton
              sx={{
                fontSize: { xs: "20px", sm: "24px" }, // Slightly smaller icon size for mobile
                padding: 0, // Removed padding around the icon
                minWidth: "auto", // Removed min-width to avoid unnecessary space
                marginTop: "0px",
              }}
            >
              {openIndex === index ? <Remove /> : <Add />}
            </IconButton>
          </Box>
          {openIndex === index && (
            <Typography
              color="#000000"
              sx={{
                marginTop: 1,
                fontSize: { xs: "12px", sm: "14px" },
                fontWeight: 300,
              }}
            >
              {faq.answer}
            </Typography>
          )}
          <Divider sx={{ marginTop: 2 }} />
        </Box>
      ))}

        <Box textAlign="center" mb={4}>
            <Button
              variant="outlined"
              sx={{
                borderColor: "#004AAD",
                color: "#004AAD",
                padding: "8px 24px",
                textTransform: "none",
                fontWeight: 600,
                fontSize: "1rem",
                borderRadius: "8px",
                '&:hover': { borderColor: '#003B7A', color: '#003B7A' },
              }}
              onClick={() => navigate('/faq')}
            >
              View More
            </Button>
        </Box>

      {/* Footer Section */}
      <Box
        sx={{
          textAlign: "center",
          padding: 4,
          backgroundImage: "url(/QAbanner.png)",
          backgroundSize: "cover",
          backgroundPosition: "center",
          borderRadius: "10px",
          marginTop: 6,
        }}
      >
        <Typography variant="h5" fontWeight="bold" gutterBottom>
          Still have a question?
        </Typography>
        <Typography
          textAlign="center"
          variant="subtitle2"
          fontStyle="italic"
          sx={{
            maxWidth: "600px",
            margin: "0 auto",
            marginBottom: 3,
            color: "#333333",
            fontSize: { xs: "10px", sm: "12px", md: "14px" },
          }}
        >
          You can submit your question or request through our contact team.
          Please provide as much detail as possible so that we can assist you
          effectively.
        </Typography>
        <Button
          variant="contained"
          sx={{
            backgroundColor: "#004AAD",
            color: "#FFFFFF",
            padding: "10px 20px",
            textTransform: "none",
            fontSize: "0.8rem",
            width: "150px",
            "&:hover": { backgroundColor: "#003B7A" },
          }}
          onClick={() => {
            try {
            window.scrollTo(0, 0);
            dispatch(setTabIndex(6));
              navigate("/contact-us");
            } catch (error) {
              navigate("/contact-us");
            }
          }}
        >
          Get in touch
        </Button>
      </Box>
    </Box>
  );
};

export default QuestionAnswer;
